var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dnd-target",on:{"dragenter":_vm.onDragEnter,"dragover":_vm.onDragOver,"dragleave":_vm.onDragLeave,"drop":_vm.onDrop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }